module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-box"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('agreementTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('comfirm')))]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('comfirmDes')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('ownerShip')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ownerShipDes')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('serviceContent')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('serviceContent1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('serviceContent2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('serviceContent3')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('serviceDesTitle')))]), _vm._v(" "), _vm._l((_vm.$t('serviceDes')), function(des, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n    " + _vm._s(des) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('openService')))]), _vm._v(" "), _vm._l((_vm.$t('openServiceDes')), function(des, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n    " + _vm._s(des) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('validityPeriod')))]), _vm._v(" "), _vm._l((_vm.$t('validityPeriodDes')), function(des, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n    " + _vm._s(des) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('unsubscribe')))]), _vm._v(" "), _vm._l((_vm.$t('unsubscribeDes')), function(des, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n    " + _vm._s(des) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('agreementPeriod')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('agreementPeriodDes')))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f95287b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/autoRenewalAgreement/AutoRenewalAgreement.vue
// module id = 1348
// module chunks = 1